module.exports = "../fonts/whatsapp_registration.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp_registration.svg
// module id = 90
// module chunks = 0